


import React, { memo, Suspense, useMemo, useEffect, useState, useContext } from "react";
import { Link } from 'react-router-dom';
import { AktionContext } from '../contexts/AktionContext';
import PhoneInput from "react-phone-input-2";
import de from 'react-phone-input-2/lang/de.json';
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import Lottie from 'lottie-react';
import Giraffe from '../assets/Celebration_Giraffe.lottie';
import Giraffe2 from '../assets/Celebration_Giraffe.json';

// ленивый DatePicker (НЕ для телефона)
const LazyDatePicker = React.lazy(() => import("react-datepicker"));

function Step7Panel(props) {
  /* const { aktionen, loadingAktionen, errorAktionen } = useContext(AktionContext);

  const ausbildungAktionen = useMemo(() => {
      if (!selectedAusbildungId) return [];
      return (aktionen || []).filter((ak) => ak.zuordnung?.some((akz) => {
        return ((akz.collection === "Ausbildungen") && String(akz.item) === String(selectedAusbildungId))
      }))
    }, [aktionen, selectedAusbildungId]);
  
    const klasseAktionen = useMemo(() => {
      if (!classIdInt) return [];
      return (aktionen || []).filter((ak) => ak.zuordnung?.some((akz) => {
        return ((akz.collection === "Klassen") && String(akz.item) === String(classIdInt))
      }))
    }, [aktionen, classIdInt]); */

  const {
    uuid,
    // NEW: управление сохранёнными экранами
    savedSummaryData,        // Angebot
    savedSummary2Data,       // Auftrag
    isEditing,
    setIsEditing,
    // режимы/флаги
    isModerator,
    isAngebotForAgree,
    angebotAnfrageId,
    formMode, setFormMode,
    isReadOnly, // вычисли у родителя: const isReadOnly = isAngebotForAgree && !isModerator;

    // сообщения/статусы
    submissionSuccess,
    submitting,
    isUpdating,
    updateMessage,
    errors = {},

    // справочники/данные
    priceCategories = [],
    finalPrices = [],   // уже посчитано в родителе: codePreise || angebotPreise || preiseOptions
    firmaPrices = [],   // уже посчитано в родителе: getPricesForAusbildung(chosenVariant?.id)
    variantPrices = [],
    places = [],
    loadingPlaces,
    errorPlaces,
    uniqueOrte = [],    // посчитай у родителя: Array.from(new Set(places.map(p => p.Ort)))

    // персональные
    titel, setTitel,
    geschlecht, setGeschlecht,
    firstName, setFirstName,
    lastName, setLastName,
    birthDate, setBirthDate,
    geburtsort, setGeburtsort,
    staatsbuergerschaft, setStaatsbuergerschaft,
    euCountryNames = [],
    nonEuCountryNames = [],

    // адрес
    strasse, setStrasse,
    hausnummer, setHausnummer,
    plz, setPlz,
    ort, setOrt,

    // контакты
    email, setEmail,
    email2, setEmail2,
    telefon, setTelefon,

    // прочее
    fuehrerscheinNummer, setFuehrerscheinNummer,
    agbChecked, setAgbChecked,

    // выборы
    selectedPlace, setSelectedPlace,
    selectedPreis, setSelectedPreis,

    // вложения
    attachments = [],
    setAttachments,

    // модераторское
    rabatt, setRabatt,
    finalPreis, // вычисляй у родителя
    preisInfos,

    // Gutschein
    availableGutscheine = [],
    selectedKlasseId,
    selectedGutscheinId, setSelectedGutscheinId,
    gutscheinCode, setGutscheinCode,
    gutscheinChecked,
    gutscheinValid,
    gutscheinAppliedData,
    gutscheinError,
    onCheckGutschein, // handler из родителя

    onOpenSignature,  // ОТКРЫТЬ модал подписи (родитель)
    onClearSignature, // СБРОС подписи (если нужно изнутри)
    onSaveSignature,  // СОХРАНИТЬ подпись (если нужно изнутри)

    // действия
    onSubmit,         // handleSubmit родителя
    onUpdateData,     // handleUpdateData родителя
  } = props;

  // 1) какая Klasse у пользователя/выбранного варианта
  const effectiveKlasseId =
    Number(
      selectedKlasseId ??
      savedSummaryData?.ausbildung?.Klasse?.id ??
      savedSummary2Data?.ausbildung?.Klasse?.id ??
      null
    ) || null;

    console.log(selectedKlasseId);

  // 2) универсальный «достань число»
  const pullId = (v) => {
    if (v == null) return null;
    if (typeof v === "number" || typeof v === "string") {
      const n = Number(v);
      return Number.isNaN(n) ? null : n;
    }
    if (typeof v === "object") {
      if (v.id != null) return pullId(v.id);
      for (const k of ["Klassen_id", "klasse_id", "Klasse_id", "klasseId", "class_id"]) {
        if (v[k] != null) return pullId(v[k]);
      }
    }
    return null;
  };

  // 3) ВАЖНО: для массивов используем Klassen_id в приоритете!
  const extractGutscheinKlassenIds = (g) => {
    if (Array.isArray(g.Klassen)) {
      return g.Klassen
        .map(x => pullId(x?.Klassen_id ?? x?.klassen_id ?? x?.id ?? x))
        .filter(Boolean);
    }
    if (Array.isArray(g.klassen)) {
      return g.klassen
        .map(x => pullId(x?.Klassen_id ?? x?.klassen_id ?? x?.id ?? x))
        .filter(Boolean);
    }
    const single =
      pullId(g.Klasse) ??
      pullId(g.klasse) ??
      pullId(g.Klasse_id) ??
      pullId(g.klasse_id);
    return single != null ? [single] : []; // [] = без привязки (универсальный)
  };

  const isDateValid = (g) => {
    const now = new Date();
    const start = g.Startdatum ? new Date(g.Startdatum) : null;
    const end = g.Enddatum ? new Date(g.Enddatum) : null;
    if (start && end) return now >= start && now <= end;
    if (start && !end) return now >= start;
    if (!start && end) return now <= end;
    return false; // без дат — не показываем
  };

  // 4) фильтр гутшайнов (по дате и по Klasse)
  const filteredGutscheine = useMemo(() => {
    if (effectiveKlasseId == null) return []; // пока класс не выбран — ничего
    const klasseStr = String(effectiveKlasseId);
    return (availableGutscheine || [])
      .filter(isDateValid)
      .filter(g => {
        const ids = extractGutscheinKlassenIds(g);
        return ids.map(String).includes(klasseStr);
        // Если нужно показывать «универсальные» вместе со специфичными:
        // return ids.length === 0 || ids.map(String).includes(klasseStr);
      });
  }, [availableGutscheine, effectiveKlasseId]);

  // если выбранный купон выпал из фильтра — сбросим
  useEffect(() => {
    if (selectedGutscheinId && !filteredGutscheine.some(g => Number(g.id) === Number(selectedGutscheinId))) {
      setSelectedGutscheinId("");
    }
  }, [filteredGutscheine, selectedGutscheinId, setSelectedGutscheinId]);

  // -------------------- Фикс выбора цены: подсветка по индексу --------------------
  // helper для финальной отображаемой цены (учёт акции)
  const getFinalShown = (price) => {
    const preisNumber = Number(price.Preis || price.preis);
    const angebotspreisNumber = Number(price.Angebotspreis || price.preis);
    const start = price.Angebot_start && new Date(price.Angebot_start);
    const end = price.Angebot_end && new Date(price.Angebot_end);
    const now = new Date();
    const isRealAngebot = start && end && now >= start && now <= end && price.Angebotspreis;
    return isRealAngebot ? angebotspreisNumber : preisNumber;
  };

  // отдельные индексы для клиента и для фирмы (списки разные)
  const [selectedKundeIndex, setSelectedKundeIndex] = useState(null);
  const [selectedFirmaIndex, setSelectedFirmaIndex] = useState(null);

  // синхронизация индекса клиента по пришедшему selectedPreis
  useEffect(() => {
    const list = ((isModerator && variantPrices?.length) ? variantPrices : finalPrices) || [];
    console.log(list);
    const match = list.findIndex(p => Number(selectedPreis) === getFinalShown(p));
    setSelectedKundeIndex(match >= 0 ? match : null);
  }, [selectedPreis, finalPrices, variantPrices, isModerator]);

  // синхронизация индекса фирмы по пришедшему selectedPreis
  useEffect(() => {
    const list = firmaPrices || [];
    const match = list.findIndex(p => Number(selectedPreis) === Number(p.Preis));
    setSelectedFirmaIndex(match >= 0 ? match : null);
  }, [selectedPreis, firmaPrices]);
  // -------------------------------------------------------------------------------

  // --------------- РЕНДЕР СОХРАНЁННЫХ БЛОКОВ (ТОЛЬКО ДЛЯ МОДЕРАТОРА) ---------------
  const renderSavedAngebot = (data) => {
    if (!data) return null;

    const {
      firstName, lastName, email, telefon,
      strasse, hausnummer, plz, ort,
      variantName,
      anfrage_ausbildung,
      preise = [],
      angebot_preise = [],
      code_preise = [],
      ausbildung_theorie,
      ausbildung_praxis,
      ausbildung_pruefung,
      ausbildung_preisinfo,
      ausbildung_exklusive,
      angebotId,
      angebotCreatedAt,
    } = data;

    console.log(data);

    const promoArray = (Array.isArray(code_preise) && code_preise.length) ? code_preise : (angebot_preise || []);

    return (
      <div className={props.styles.savedSummary}>
        <p><b style={{ color: "var(--primary)" }}>Angebot Nr. </b> {angebotId} | {angebotCreatedAt}</p>

        <p>
          {firstName} {lastName}<br />
          {email}<br />
          {telefon}<br />
          {strasse || ""} {hausnummer || ""}<br />
          {plz || ""} {ort || ""}
        </p>

        console.log(variantName);

        {variantName ? (
          <div className={props.styles.overwievBlock}>
            <h3 style={{ color: "var(--primary)" }}>Deine Anfrage</h3>
            <p>Führerschein: Klasse {anfrage_ausbildung.Klasse?.Name || anfrage_ausbildung.klasse?.name || "unbekannt"}</p>
            <p>Ausbildungsvariante: {variantName || variantName || "nicht angegeben"}</p>
          </div>
        ) : (
          <p>Keine Ausbildungsinformationen gefunden.</p>
        )}

        <p>
          Lieber {firstName},<br />
          vielen Dank für deine Anfrage! Gerne übermitteln wir dir dein persönliches Angebot.
        </p>

        <div style={{ marginLeft: '1rem' }}>
          <h2 style={{ color: "var(--primary)" }}>Dein Angebot</h2>
        </div>

        <p style={{ marginBottom: 0, color: "var(--accent)" }}><strong>Theoretischer Teil:</strong></p>
        <div className={props.styles.blockContent}
          dangerouslySetInnerHTML={{ __html: ausbildung_theorie || "<em>-</em>" }} />

        <p style={{ marginBottom: 0, color: "var(--accent)" }}><strong>Praktischer Teil:</strong></p>
        <div className={props.styles.blockContent}
          dangerouslySetInnerHTML={{ __html: ausbildung_praxis || "<em>-</em>" }} />

        <p style={{ marginBottom: 0, color: "var(--accent)" }}><strong>Prüfungen:</strong></p>
        <div className={props.styles.blockContent}
          dangerouslySetInnerHTML={{ __html: ausbildung_pruefung || "<em>-</em>" }} />

        <strong style={{ color: "var(--primary)" }}>Dein Preis</strong>
        <div className={props.styles.priceContainer}>
          {Array.isArray(preise) && preise.length > 0 ? (
            preise.map((p, index) => {
              const oldPrice = Number(p.preis).toLocaleString("de-DE", { maximumFractionDigits: 0 }) + " €";
              const promo = promoArray[index];
              const newPrice = promo
                ? Number(promo.preis).toLocaleString("de-DE", { maximumFractionDigits: 0 }) + " €"
                : null;

              return (
                <div key={index} className={props.styles.priceItem}>
                  <div>
                    <strong>{p.kategorieName || "Allgemein"}</strong>
                    {p.kategorieBeschreibung && (
                      <div style={{ fontSize: "0.9em", opacity: 0.8 }}>{p.kategorieBeschreibung}</div>
                    )}
                  </div>
                  <div style={{ marginTop: "0.2em" }}>
                    {newPrice ? (
                      <>
                        <span style={{ textDecoration: "line-through", color: "#888", fontSize: "0.9em" }}>{oldPrice}</span>{" "}
                        <strong style={{ fontSize: "1.1em" }}>{newPrice}</strong>
                      </>
                    ) : (
                      <strong>{oldPrice}</strong>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className={props.styles.noPrice}>–</div>
          )}
        </div>

        <p style={{ marginBottom: 0 }}><strong>Wir garantieren Prüfungstermine!</strong></p>
        <p style={{ marginTop: 0 }}>
          jeden Montag theoretische Prüfung in Baden<br />
          jeden Dienstag theoretische Prüfung in Traiskirchen<br />
          <b>jeden Freitag praktische Prüfung in Baden</b>
        </p>
      </div>
    );
  };

  const renderSavedAuftrag = (data) => {
    if (!data) return null;

    const {
      firstName, lastName, email, telefon,
      strasse, hausnummer, plz, ort,
      klass,
      kombi,
      variantName,
      ausbildung,
      preise = [],
      gutschein,
      ausgewaehlterPreis,
      ausbildung_theorie,
      ausbildung_praxis,
      ausbildung_pruefung,
      ausbildung_preisinfo,
      ausbildung_exklusive,
      angebotId,
      angebotCreatedAt,
    } = data;

    console.log(data);

    // находим выбранную цену и её категорию
    const selectedPrice = preise.find(p => Number(p.preis || p.Preis) === Number(ausgewaehlterPreis));
    const catId = selectedPrice?.Preiskategorie || selectedPrice?.kategorie_id;
    const cat = props.priceCategories.find(p => p.id === catId) ||
      props.priceCategories.find(p => p.Name === selectedPrice?.kategorieName);

    return (
      <>
        <h2 className={props.styles.title}>Zusammenfassung</h2>
        <p>Kontrolliere deine Angaben noch einmal gründlich und wenn alles passt kannst du uns mit deiner Unterschrift gleich den Auftrag erteilen.</p>
      
        <div className={props.styles.savedSummary}>
          <header>
            <div className={props.styles.headerContainer}>
              <hgroup>
                <h2><strong>Ausbildungsauftrag</strong> Nr. {angebotId}</h2>
                <span><small>vom</small> {angebotCreatedAt}</span>
              </hgroup>

              {klass != "-" && (
                <div className={props.styles.overwievBlock}>
                    <p><strong>Führerschein:</strong> Klasse {klass || ausbildung.Klasse?.Name || ausbildung.klasse?.name || "unbekannt"} <br />
                    <strong>Ausbildungsvariante:</strong> {variantName || ausbildung.name || "nicht angegeben"}</p>
                </div>
              )}

              {kombi != "-" && (
                <div className={props.styles.overwievBlock}>
                    <p><strong>Kombi:</strong> {kombi || ausbildung.Klasse?.Name || ausbildung.klasse?.name || "unbekannt"} <br />
                    <strong>Ausbildungsvariante:</strong> {variantName || ausbildung.name || "nicht angegeben"}</p>
                </div>
              )}

              
            </div>
          </header>

          <main>
            <section id="kundendaten">
              <p>Auftrag für den oben angeführten Ausbildungsgegenstand, abgeschlossen zwischen {process.env.REACT_APP_FS_NAME} und:</p>

              <p>
                <strong>{firstName} {lastName}</strong><br />
                {strasse || ""} {hausnummer || ""}<br />
                {plz || ""} {ort || ""}
              </p>

              <p>
                {email}<br />
                {telefon}
              </p>
            </section>

            <section className={props.styles.auftragLeistung}>
              <h2>Leistungsverzeichnis</h2>

              <h3>Theoretischer Teil:</h3>
              <div className={props.styles.blockContent}
                dangerouslySetInnerHTML={{ __html: ausbildung_theorie || "<em>-</em>" }} />

              <h3>Praktischer Teil:</h3>
              <div className={props.styles.blockContent}
                dangerouslySetInnerHTML={{ __html: ausbildung_praxis || "<em>-</em>" }} />

              <h3>Prüfungen:</h3>
              <div className={props.styles.blockContent}
                dangerouslySetInnerHTML={{ __html: ausbildung_pruefung || "<em>-</em>" }} />
            </section>

            <section className={props.styles.auftragPricing}>
              
              <div className={props.styles.auftragPriceContainer}>
                {console.log(selectedPrice)}
                {selectedPrice ? (
                  <>
                    <div className={props.styles.auftragPriceDescr}>
                      <h2>Dein Preis</h2>
                      <h4>{(cat?.Name || selectedPrice.kategorieName || "Allgemein")}</h4>
                      {cat?.Beschreibung ? `${cat.Beschreibung}` : ""}
                    </div>
                    <div className={props.styles.auftragPriceAmount}>
                      {console.log(gutscheinAppliedData)}
                      {gutscheinAppliedData ? (
                        <>
                          {Number((selectedPrice.preis || selectedPrice.Preis) - (gutscheinAppliedData.Rabatt || gutscheinAppliedData.rabatt)).toLocaleString("de-DE", { minimumFractionDigits: 0 })} €{" "}
                          <span className={props.styles.oldPrice}>statt {Number(selectedPrice.preis || selectedPrice.Preis).toLocaleString("de-DE", { minimumFractionDigits: 0 })} €{" "}</span>
                        </>
                      ) : (
                        <>{Number(selectedPrice.preis || selectedPrice.Preis).toLocaleString("de-DE", { minimumFractionDigits: 0 })} €{" "}</>
                      )}
                    </div>
                  </>
                ) : ausgewaehlterPreis ? (
                  <div className={props.styles.priceItem}>
                    {Number(ausgewaehlterPreis).toLocaleString("de-DE", { minimumFractionDigits: 0 })} €
                  </div>
                ) : (
                  <div className={props.styles.noPrice}>–</div>
                )}
              </div>

              <p className={props.styles.legalText}>{ausbildung_preisinfo ? ausbildung_preisinfo : "Externe Kosten wie ärztliches Gutachten, Erste-Hilfe-Kurs, Behördengebühren je nach Anzahl der Prüfungsantritte und ausbildungsunabhängige Fahrschulkosten sowie diverse Lehrmaterialien sind nicht in obigen Preisen enthalten. Genaueres findest du im Angebot."}</p>
              <p className={props.styles.legalText}>Alle Preise und Angaben vorbehaltlich Satz- und Druckfehler. Bei offensichtlichen Irrtümern behalten wir uns die Korrektur oder den Rücktritt vom Vertrag vor.</p>
              <p>Es gelten die <a href="/agb" target="_blank" title="Allgemeine Geschäftsbedingungen">AGB</a> und <a href="/datenschutz" target="_blank" title="Datenschutzbestimmungen">Datenschutzbestimmungen</a> der {process.env.REACT_APP_FS_NAME}.</p>
            </section>
            <section className={props.styles.controls}>
              <button
                type="button"
                className={props.styles.cancelBtn}
                onClick={() => setIsEditing && setIsEditing(true)}
              >
                Bearbeiten
              </button>
              <button
                type="button"
                onClick={() => onOpenSignature && onOpenSignature()}
                className={`${props.styles.signatureBtn} button pagelink`}
              >
                Unterschreiben
              </button>
            </section>
          </main>
        </div>
        <div className={`${props.styles.successOverlay} ${updateMessage && "open"}`}>
          <div className={props.styles.successMSG}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#155724"><path d="m424-408-86-86q-11-11-28-11t-28 11q-11 11-11 28t11 28l114 114q12 12 28 12t28-12l226-226q11-11 11-28t-11-28q-11-11-28-11t-28 11L424-408Zm56 328q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
            <h1>Geschafft!</h1>
            <p>{updateMessage}</p>
            {/* <button className="large button pagelink">Mehr Infos zur Klasse</button> */}
            <Link to="/" className="large button pagelink">Zurück zur Startseite</Link>
          </div>
        </div>
      </>
    );
  };

  // РАННИЙ ВОЗВРАТ: показываем сохранённые экраны ТОЛЬКО модератору
  /* if (isModerator && !isEditing && (savedSummary2Data || savedSummaryData)) { */
  if (!isEditing && savedSummary2Data) {
    return (
      <div className={props.styles.savedSummaryContainer}>
        {/* {savedSummary2Data ? renderSavedAuftrag(savedSummary2Data) : renderSavedAngebot(savedSummaryData)} */}
        { renderSavedAuftrag(savedSummary2Data) }

        {/* <div className={props.styles.formGroup} style={{ marginTop: "1rem" }}>
          <button
            type="button"
            className={props.styles["summary-submit"]}
            onClick={() => setIsEditing && setIsEditing(true)}
          >
            Bearbeiten
          </button>
        </div> */}
      </div>
    );
  }

  const safeSetEmail2 = typeof setEmail2 === "function" ? setEmail2 : () => { };

  const renderPriceCard = (price, selected, onClick) => {
    const preisNumber = Number(price.Preis || price.preis);
    const angebotspreisNumber = Number(price.Angebotspreis || price.preis);
    const catId = price.Preiskategorie || price.kategorie_id;

    const cat =
      priceCategories.find((p) => p.id === catId)/*  ||
      priceCategories.find((p) => p.Name === price.kategorieName) */;

    const angebotStart = price.Angebot_start && new Date(price.Angebot_start);
    const angebotEnd = price.Angebot_end && new Date(price.Angebot_end);
    const today = new Date();

    const isRealAngebot =
      angebotStart && angebotEnd && today >= angebotStart && today <= angebotEnd && price.Angebotspreis;

    const isReduced =
      price.Preis && price.preis && Number(price.Preis) !== Number(price.preis);

    const finalShown = isRealAngebot ? angebotspreisNumber : preisNumber;

    return (
      <div
        key={price.id}
        className={`${props.styles.priceOption} ${selected ? props.styles.selected : ""}`}
        onClick={onClick}
      >
        <strong>
          {cat?.Name || price.kategorieName || "Allgemein"}{" "}
          {cat?.Code || price.kategorieCode ? (
            <span className={props.styles.code}>({cat?.Code || price.kategorieCode})</span>
          ) : null}
        </strong>

        <div className={props.styles.priceAmount}>
          {isRealAngebot ? (
            <>
              {/* <s>{preisNumber.toLocaleString("de-DE")} €</s>{" "} */}
              {angebotspreisNumber.toLocaleString("de-DE")} €<br />
              <span className={props.styles.oldPrice}>Statt {preisNumber.toLocaleString("de-DE")} €</span>
            </>
          ) : isReduced ? (
            <>
              {/* <s>{Number(price.Preis).toLocaleString("de-DE")} €</s>{" "} */}
              {Number(price.preis).toLocaleString("de-DE")} €<br />
              <span className={props.styles.oldPrice}>statt {preisNumber.toLocaleString("de-DE")} €</span>
            </>
          ) : (
            <span>{finalShown.toLocaleString("de-DE")} €</span>
          )}
        </div>

        <small>{cat?.Beschreibung || price.kategorieBeschreibung || ""}</small>
        {price.zusatz && (
          <div className={props.styles.zusatzLabel}>
            {price.zusatz}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={props.styles.stepForm}>
      <h2 className={props.styles.title}>
        {/* {props.uuid ? "Da geht’s zum Auftrag!" : "One more step!"} */}
        {props.uuid ? "Da geht’s zum Auftrag!" : "Fast geschafft!"}
      </h2>
        {/* <p>
          Damit wir dir dein persönliches Angebot direkt per E-Mail schicken können, brauchen wir jetzt nur
          noch deine Kontaktdaten. Versprochen: Wir verwenden deine Angaben nur für dieses Angebot – sonst für nichts.
        </p> */}

        <p>
  {props.uuid ? (
    <>
      Damit wir dir dein persönliches Auftragsformular direkt per E-Mail schicken können, brauchen wir jetzt nur
      noch deine Kontaktdaten.</>
  ) : (
    <>
      {/* <p>Dein persönliches Angebot ist ready, uns fehlen nur noch deine Kontaktdaten.</p>
      <p>E-Mail & Co. eintragen, Angebot bekommen, fertig. Deine Daten nutzen wir ausschließlich dafür, no spam, no nonsense.</p> */}
      <p>Damit wir dir dein persönliches Angebot direkt per E-Mail schicken können, brauchen wir jetzt nur noch deine Kontaktdaten. Versprochen: Wir verwenden deine Angaben nur für dieses Angebot – sonst für nichts.</p>
    </>
  )}
</p>

      <div style={{ position: "relative" }}>
        <form
          className={props.styles.form}
          /* style={!isAngebotForAgree ? { paddingBottom: "2.5rem", marginTop: "2.5rem" } : {}} */
          onSubmit={(e) => {
            e.preventDefault();
            /* onSubmit && onSubmit(e); */
          }}
        >
          {Object.keys(errors).length > 0 && (
            <div className={props.styles.error}>
              <div className={props.styles.errorMsg}>
                <h4>Leider sind folgende Fehler aufgetreten.</h4>
                <ul>
                  {errors.price && (<li> {errors.price}</li>)}
                  {errors.email && (<li> {errors.email}</li>)}
                  {errors.agbChecked && (<li> {errors.agbChecked}</li>)}
                </ul>
                <p>Bitte korrigiere die rot markierten Felder und versuche es erneut.</p>
              </div>
            </div>
          )}

          {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
            <div className={props.styles.formSection}>
              <h3>Wähle eine Option</h3>
              <div className={`${props.styles.formGroup} ${props.styles.priceWrapper}`}>
                {/* <label className={props.styles.label}>Wähle eine der folgenden Optionen</label> */}
                <div className={props.styles.priceOptionsWrapper}>
                  {(
                    (isModerator && variantPrices?.length ? variantPrices : finalPrices) || []
                  ).map((price, index) => {
                    const finalShown = getFinalShown(price);
                    const selected = selectedKundeIndex === index;
                    return renderPriceCard(
                      price,
                      selected,
                      () => {
                        setSelectedPreis(finalShown);   // бизнес-значение
                        setSelectedKundeIndex(index);   // подсветка по индексу
                        props.setSelectedPreisIndex?.(index);
                      }
                    );
                  })}
                </div>
              </div>
              <p className={props.styles.priceOptionsDescr}>
                {preisInfos ? preisInfos : "Externe Kosten wie ärztliches Gutachten, Erste-Hilfe-Kurs, Behördengebühren je nach Anzahl der Prüfungsantritte und ausbildungsunabhängige Fahrschulkosten sowie diverse Lehrmaterialien sind nicht in obigen Preisen enthalten. Genaueres findest du im Angebot." }
              </p>
            </div>
          )}

          {isModerator && (
            <div className={props.styles.formSection}>
              <div style={{ alignSelf: "end", width: "60%" }}>
                <div className={props.styles.toggleButtonsWrapper}>
                  <button
                    type="button"
                    onClick={() => setFormMode("kunde")}
                    className={`${props.styles.toggleButton} ${formMode === "kunde" ? props.styles.toggleButtonActive : ""}`}
                  >
                    Kunde
                  </button>
                  <button
                    type="button"
                    onClick={() => setFormMode("firma")}
                    className={`${props.styles.toggleButton} ${formMode === "firma" ? props.styles.toggleButtonActive : ""}`}
                  >
                    Firma
                  </button>
                </div>
              </div>
            </div>
          )}

            {formMode === "kunde" ? (
              <>
                <div className={props.styles.formSection}>
                  <h3>Persönliche Daten</h3>

                  {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
                    <>
                      <div className={props.styles.formGroup}>
                        <label className={props.styles.label}>Titel</label>
                        <input
                          type="text"
                          value={titel}
                          onChange={(e) => setTitel(e.target.value)}
                          className={props.styles.input}
                        />
                      </div>

                      <div className={props.styles.formGroup}>
                        <label className={props.styles.label}>Geschlecht</label>
                        <select
                          value={geschlecht}
                          onChange={(e) => setGeschlecht(e.target.value)}
                          className={props.styles.input}
                        >
                          <option value="">Bitte wählen</option>
                          <option value="w">Weiblich</option>
                          <option value="m">Männlich</option>
                          <option value="d">Divers</option>
                        </select>
                      </div>
                    </>
                  )}

                  {/* {submissionSuccess && !isModerator && ( */}
                    <div className={`${props.styles.successOverlay} ${submissionSuccess && !isModerator && "open"}`}>
                      <div className={props.styles.successMSG}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#fefefe"><path d="m424-408-86-86q-11-11-28-11t-28 11q-11 11-11 28t11 28l114 114q12 12 28 12t28-12l226-226q11-11 11-28t-11-28q-11-11-28-11t-28 11L424-408Zm56 328q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                        <h1>Geschafft!</h1>
                        <p>Deine Anfrage wurde erfolgreich versendet! Wir melden uns in Kürze per E-Mail bei dir.</p>
                        {/* <button className="large button pagelink">Mehr Infos zur Klasse</button> */}
                        <Link to="/" className="large button pagelink">Zurück zur Startseite</Link>
                      </div>
                      
                      {/* <Lottie animationData={Giraffe2} style={{ position: "fixed", zIndex: "9999", bottom: "10%", right: 0, width: "100%" }} autoPlay loop /> */}
                      {/* <dotlottie-wc src={Giraffe}  autoplay="true" loop="false"></dotlottie-wc> */}
                    </div>
                  {/* )} */}

                  <div className={`${props.styles.formGroup} ${errors.firstName ? props.styles.errorFlag : errors.firstName}`}>
                    <label className={props.styles.label}>Vorname<span>*</span></label>
                    <input
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                      className={`${props.styles.input} ${props.styles.anfrage_input_name}`}
                    />
                    {/* {errors.firstName && <p className={props.styles.error2}>{errors.firstName}</p>} */}
                  </div>

                  <div className={`${props.styles.formGroup} ${errors.lastName ? props.styles.errorFlag : ''}`}>
                    <label className={props.styles.label}>Nachname<span>*</span></label>
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                      className={`${props.styles.input} ${props.styles.anfrage_input_name}`}
                    />
                    {/* {errors.lastName && <p className={props.styles.error2}>{errors.lastName}</p>} */}
                  </div>

                  {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
                    <>
                      <div className={`${props.styles.formGroup} ${props.styles.formBirthDate} ${errors.birthDate ? props.styles.errorFlag : ''}`}>
                        <label className={props.styles.label}>Geburtsdatum<span>*</span></label>
                        <div style={{ width: "100%" }}>
                          <Suspense
                            fallback={
                              <input
                                type="date"
                                className={props.styles.input}
                                onChange={(e) => {
                                  const v = e.target.value; // yyyy-MM-dd
                                  if (v) {
                                    const [yy, mm, dd] = v.split("-");
                                    setBirthDate(new Date(Number(yy), Number(mm) - 1, Number(dd)));
                                  } else {
                                    setBirthDate(null);
                                  }
                                }}
                              />
                            }
                          >
                            <LazyDatePicker
                              locale="de"
                              selected={birthDate}
                              onChange={(date) => setBirthDate(date)}
                              dateFormat="dd.MM.yyyy"
                              maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 14))}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 100))}
                              showYearDropdown
                              showMonthDropdown
                              scrollableYearDropdown
                              yearDropdownItemNumber={100}
                              className={props.styles.input}
                              withPortal
                            />
                          </Suspense>
                        </div>
                      </div>

                      <div className={`${props.styles.formGroup} ${props.styles.formBirthCity}  ${errors.geburtsort ? props.styles.errorFlag : ''}`}>
                        <label className={props.styles.label}>Geburtsort<span>*</span></label>
                        <input
                          type="text"
                          value={geburtsort}
                          onChange={(e) => setGeburtsort(e.target.value)}
                          className={props.styles.input}
                          required
                        />
                      </div>

                      <div className={`${props.styles.formGroup} ${props.styles.formCitizenship}  ${errors.staatsbuergerschaft ? props.styles.errorFlag : ''}`}>
                        <label className={props.styles.label}>Staatsbürgerschaft<span>*</span></label>
                        <select
                          value={staatsbuergerschaft}
                          onChange={(e) => setStaatsbuergerschaft(e.target.value)}
                          className={props.styles.input}
                          required
                        >
                          <option value="">Bitte wählen</option>
                          <optgroup label="EU-Länder">
                            {euCountryNames.map((country, idx) => (
                              <option key={`eu-${idx}`} value={country}>
                                {country}
                              </option>
                            ))}
                          </optgroup>
                          <optgroup label="Nicht-EU-Länder">
                            {nonEuCountryNames.map((country, idx) => (
                              <option key={`non-eu-${idx}`} value={country}>
                                {country}
                              </option>
                            ))}
                          </optgroup>
                        </select>
                      </div>
                    </>
                  )}             
                </div>
              
                {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
                  <div className={props.styles.formSection}>
                    <h3>Adressdaten</h3>
                    <div className={`${props.styles.formGroup} ${props.styles.formStreet} ${errors.strasse ? props.styles.errorFlag : ''}`}>
                      <label className={props.styles.label}>Straße<span>*</span></label>
                      <input
                        type="text"
                        value={strasse}
                        onChange={(e) => setStrasse(e.target.value)}
                        className={props.styles.input}
                        required
                      />
                    </div>
                    <div className={`${props.styles.formGroup} ${props.styles.formNumber} ${errors.hausnummer ? props.styles.errorFlag : ''}`}>
                      <label className={props.styles.label}>Hausnummer<span>*</span></label>
                      <input
                        type="text"
                        value={hausnummer}
                        onChange={(e) => setHausnummer(e.target.value)}
                        className={props.styles.input}
                        required
                      />
                    </div>
                    <div className={`${props.styles.formGroup} ${props.styles.formPLZ} ${errors.plz ? props.styles.errorFlag : ''}`}>
                      <label className={props.styles.label}>PLZ<span>*</span></label>
                      <input
                        type="text"
                        value={plz}
                        onChange={(e) => setPlz(e.target.value)}
                        className={props.styles.input}
                        required
                      />
                    </div>
                    <div className={`${props.styles.formGroup} ${props.styles.formCity} ${errors.ort ? props.styles.errorFlag : ''}`}>
                      <label className={props.styles.label}>Ort<span>*</span></label>
                      <input
                        type="text"
                        value={ort}
                        onChange={(e) => setOrt(e.target.value)}
                        className={props.styles.input}
                        required
                      />
                    </div>
                  </div>
                )}

                <div className={props.styles.formSection}>
                  <h3>Kontaktdaten</h3>
                  <div className={`${props.styles.formGroup} ${props.styles.formEmail} ${errors.email ? props.styles.errorFlag : ''}`}>
                    <label className={props.styles.label}>E-Mail Adresse</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className={`${props.styles.input} ${isAngebotForAgree ? props.styles.disabled : ""}`}
                      disabled={isReadOnly}
                    />
                    {/* {errors.email && <p className={props.styles.error2}>{errors.email}</p>} */}
                  </div>
                  
                  <div className={`${props.styles.formGroup} ${props.styles.formEmail} ${errors.email ? props.styles.errorFlag : ''}`}>
                    <label className={` ${props.styles.label} ${isAngebotForAgree && props.styles.inputHidden } `}>E-Mail Adresse bestätigen</label>
                    <input
                      type={`${isAngebotForAgree ?  "hidden"  :  "email" }`}
                      value={email2}
                      onChange={(e) => setEmail2(e.target.value)}
                      required
                      className={`${props.styles.input} ${isAngebotForAgree ? props.styles.disabled : ""}`}
                      disabled={isReadOnly}
                    />
                  </div>

                  <div className={`${props.styles.formGroup} ${props.styles.formTel}  ${errors.telefon ? props.styles.errorFlag : ''}`}>
                    <label className={props.styles.label}>Telefon</label>
                    <PhoneInput
                      country="at"
                      localization={de}
                      value={typeof telefon === "string" ? telefon : ""}
                      onChange={(val) => setTelefon(val)}
                      preferredCountries={["at", "de", "ch"]}
                      preserveOrder={['preferredCountries']}
                      enableSearch={true}
                      searchPlaceholder="Nach Land suchen"
                      disableSearchIcon={false}
                      inputProps={{
                        name: "telefon",
                        required: true,
                        id: "telefon",
                        autoComplete: "off",
                      }}
                      inputClass={`${props.styles.input} ${isAngebotForAgree ? props.styles.disabled : ""}`}
                    />
                    {/* {errors.telefon && <p className={props.styles.error2}>{errors.telefon}</p>} */}
                  </div>
                </div>

                {!isAngebotForAgree && (
                  <div className={props.styles.formSection}>
                    <h3 className={props.styles["start-ort-title"]}>Wo möchtest du starten?</h3>
                    <div className={props.styles["start-ort-container"]}>
                      {loadingPlaces ? (
                        <p>Laden der Standorte...</p>
                      ) : errorPlaces ? (
                        <p>Fehler beim Laden der Standorte: {errorPlaces}</p>
                      ) : uniqueOrte && uniqueOrte.length > 0 ? (
                        <div className={props.styles["start-ort-grid"]}>
                          {uniqueOrte.map((o, idx) => (
                            <div
                              key={idx}
                              className={`${props.styles["start-ort-item"]} ${selectedPlace === o ? props.styles["start-ort-item-selected"] : ""
                                }`}
                              onClick={() => setSelectedPlace(o)}
                            >
                              {o}
                            </div>
                          ))}
                          <div
                            className={`${props.styles["start-ort-item"]} ${selectedPlace === "egal" ? props.styles["start-ort-item-selected"] : ""
                              }`}
                            onClick={() => setSelectedPlace("egal")}
                          >
                            egal
                          </div>
                        </div>
                      ) : (
                        <p>Standorte nicht gefunden</p>
                      )}
                    </div>
                  </div>
                )}
                

                {/* {!isAngebotForAgree && ( */}
                  <div className={props.styles.formSection}>
                    <h3>Gutschein</h3>
                    <div className={props.styles.formCouponSection}>
                      {isModerator ? (
                        <div className={`${props.styles.formGroup} ${props.styles.formCouponSelect}`}>
                          <label className={props.styles.label}>Gutscheincode auswählen</label>
                          <select
                            className={props.styles.input}
                            value={selectedGutscheinId || ""}
                            onChange={(e) => setSelectedGutscheinId(Number(e.target.value))}
                          >
                            <option value="">— Kein Gutschein ausgewählt —</option>
                            {filteredGutscheine.map((g) => (
                              <option key={g.id} value={g.id}>
                                {g.Code} – {Number(g.Rabatt).toFixed(2)} €
                                {g.Startdatum && g.Enddatum
                                  ? ` (${new Date(g.Startdatum).toLocaleDateString("de-DE")} bis ${new Date(
                                    g.Enddatum
                                  ).toLocaleDateString("de-DE")})`
                                  : ""}
                              </option>
                            ))}
                          </select>
                        </div>
                      ) : (
                        <div className={`${props.styles.formGroup} ${props.styles.formCoupon}`}>
                          {/* <label  className={props.styles.label}>Gutscheincode:</label> */}
                          <div className={props.styles.formCouponGroup}>
                            <input
                              type="text"
                              value={gutscheinCode}
                              onChange={(e) => {
                                setGutscheinCode(e.target.value);
                              }}
                              placeholder="zB. SOMMER2025"
                              className={`${props.styles.input} ${props.styles.inputCoupon}`}
                            />
                            <button
                              type="button"
                              onClick={onCheckGutschein}
                              className={props.styles.checkButton}
                            >
                              Prüfen
                            </button>
                          </div>
                        </div>
                      )}

                      {gutscheinChecked && gutscheinValid && gutscheinAppliedData && (
                        <div className={props.styles.couponCheckSuccess}>
                          ✅ {gutscheinAppliedData.code} – {gutscheinAppliedData.rabatt.toFixed(2)} €
                        </div>
                      )}

                      {gutscheinChecked && !gutscheinValid && (
                        <div className={props.styles.couponCheckError}>
                          {gutscheinError}
                        </div>
                      )}
                    </div>
                  </div>
                {/* )} */}

                {/* Документы */}
                {/* {(isAngebotForAgree || (isModerator && angebotAnfrageId)) && (
                  <div className={props.styles.formSection}>
                    <h3>Dokumente</h3>
                    <div className={`${props.styles.formGroup} ${props.styles.formUpload}`}>
                      <label className={props.styles.fileUploadCustom}>
                        <div className={props.styles.plusCircle}>+</div>
                        <span className={props.styles.fileHint}>(z. B. Reisepass, Ausweis, Führerschein)</span>
                        <input
                          type="file"
                          multiple
                          accept="image/*"
                          onChange={(e) => {
                            const input = e.target;
                            const newFiles = Array.from(input && input.files ? input.files : []);
                            setAttachments((prev) => [...prev, ...newFiles]);
                            e.target.value = "";
                          }}
                          className={props.styles.inputHidden}
                        />
                      </label>

                      {attachments.length > 0 && (
                        <ul className={props.styles.fileList}>
                          {attachments.map((file, index) => (
                            <li key={index} className={props.styles.fileListItem}>
                              {file.name}
                              <button
                                type="button"
                                className={props.styles.removeFileButton}
                                onClick={() => {
                                  setAttachments((prev) => prev.filter((_, i) => i !== index));
                                }}
                              >
                                ×
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                )} */}

                {/* Модераторские поля */}
                {(isModerator && angebotAnfrageId) && (
                  <div className={props.styles.formSection}>
                    <h3>Manueller Rabatt</h3>
                    <div className={props.styles.formGroup}>
                      <label className={props.styles.label}>Rabatt (in €)</label>
                      <input
                        type="number"
                        className={props.styles.input}
                        value={Number.isFinite(rabatt) ? rabatt : 0}
                        onChange={(e) => setRabatt(Number(e.target.value || 0))}
                        min={0}
                        step={1}
                      />
                    </div>

                    <div className={props.styles.formGroup}>
                      <label className={props.styles.label}>Endpreis nach Rabatt</label>
                      <input
                        type="text"
                        className={props.styles.input}
                        value={`${(Number.isFinite(finalPreis) ? finalPreis : 0).toLocaleString("de-DE", {
                          minimumFractionDigits: 0,
                        })} €`}
                        readOnly
                      />
                    </div>
                  </div>
                )}
              </>
            ) : (
              // ───────────────────────── Firma ─────────────────────────
              <>
                <div className={props.styles.formSection}>
                  <h3>Firmendaten</h3>

                  {submissionSuccess && !isModerator && (
                    <div className={props.styles.successMSG}>
                      ✅ Deine Anfrage wurde erfolgreich versendet! Wir melden uns in Kürze per E-Mail.
                    </div>
                  )}

                  <div className={props.styles.formGroup}>
                    <label className={props.styles.label}>Firmenname</label>
                    <input
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                      className={props.styles.input}
                    />
                    {/* {errors.firstName && <p className={props.styles.error2}>{errors.firstName}</p>} */}
                  </div>

                  <div className={props.styles.formGroup}>
                    <label className={props.styles.label}>Kontaktperson</label>
                    <input
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                      className={props.styles.input}
                    />
                    {/* {errors.lastName && <p className={props.styles.error2}>{errors.lastName}</p>} */}
                  </div>
                </div>

                <div className={props.styles.formSection}>
                  <h3>Kontaktdaten</h3>
                  <div className={`${props.styles.formGroup} ${props.styles.formEmail}`}>
                    <label className={props.styles.label}>E-Mail Adresse<span>*</span></label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className={`${props.styles.input} ${isAngebotForAgree ? props.styles.disabled : ""}`}
                      disabled={isReadOnly}
                    />
                    {/* {errors.email && <p className={props.styles.error2}>{errors.email}</p>} */}
                  </div>

                  <div className={`${props.styles.formGroup} ${props.styles.formEmail}`}>
                    <label className={props.styles.label}>E-Mail Adresse bestätigen<span>*</span></label>
                    <input
                      type="email"
                      value={email2}
                      onChange={(e) => setEmail2(e.target.value)}
                      required
                      className={`${props.styles.input} ${isAngebotForAgree ? props.styles.disabled : ""}`}
                      disabled={isReadOnly}
                    />
                    {/* {errors.email2 && <p className={props.styles.error2}>{errors.email2}</p>} */}
                  </div>

                  <div className={`${props.styles.formGroup} ${props.styles.formTel}`}>
                    <label className={props.styles.label}>Telefon<span>*</span></label>
                    <PhoneInput
                      country="at"
                      value={typeof telefon === "string" ? telefon : ""}
                      onChange={(val) => setTelefon(val)}
                      preferredCountries={["at", "de", "ch"]}
                      enableSearch={true}
                      disableSearchIcon={false}
                      inputProps={{
                        name: "telefon",
                        required: true,
                        id: "telefon",
                        autoComplete: "tel",
                      }}
                      inputClass={`${props.styles.input} ${isAngebotForAgree ? props.styles.disabled : ""}`}
                    />
                    {/* {errors.telefon && <p className={props.styles.error2}>{errors.telefon}</p>} */}
                  </div>
                </div>

                <div className={props.styles.formSection}>
                  {/* цены для фирмы */}
                  {firmaPrices && firmaPrices.length > 0 && (
                    <>
                      <h3>Deine Optionen</h3>
                      <div className={`${props.styles.formGroup} ${props.styles.priceWrapper}`}>
                        <label className={props.styles.label}>Preisvariante:</label>
                        <div className={props.styles.priceOptionsWrapper}>
                          {firmaPrices.map((price, index) => {
                            const preisVal = Number(price.Preis);
                            const selected = selectedFirmaIndex === index;
                            return (
                              <div
                                key={index}
                                className={`${props.styles.priceOption} ${selected ? props.styles.selected : ""}`}
                                onClick={() => {
                                  setSelectedPreis(preisVal);
                                  setSelectedFirmaIndex(index);
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <strong>
                                  {(
                                    priceCategories.find((p) => p.id === (price.Preiskategorie || price.kategorie_id)) || {}
                                  ).Name || "Allgemein"}
                                </strong>
                                <div className={props.styles.priceAmount}>
                                  {preisVal.toLocaleString("de-DE")} €
                                </div>
                                <small>
                                  {(
                                    priceCategories.find((p) => p.id === (price.Preiskategorie || price.kategorie_id)) || {}
                                  ).Beschreibung || ""}
                                </small>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </>
                  )}

                  {isModerator && (
                    <>
                      <div className={props.styles.formGroup}>
                        <label className={props.styles.label}>Rabatt (in €)</label>
                        <input
                          type="number"
                          className={props.styles.input}
                          value={Number.isFinite(rabatt) ? rabatt : 0}
                          onChange={(e) => setRabatt(Number(e.target.value || 0))}
                          min={0}
                          step={1}
                        />
                      </div>

                      <div className={props.styles.formGroup}>
                        <label className={props.styles.label}>Endpreis nach Rabatt</label>
                        <input
                          type="text"
                          className={props.styles.input}
                          value={`${(Number.isFinite(finalPreis) ? finalPreis : 0).toLocaleString("de-DE", {
                            minimumFractionDigits: 0,
                          })} €`}
                          readOnly
                        />
                      </div>
                    </>
                  )}
                </div>
              </>
            )}

            <div className={props.styles.formSectionSubmit}>
              {/* AGB */}
              <div className={`${props.styles.formGroup} ${props.styles.formCheck} ${errors.agbChecked ? props.styles.errorFlag : ''}`}>
                <label
                  className={props.styles.label}
                  style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                >
                  <input
                    type="checkbox"
                    checked={!!agbChecked}
                    onChange={(e) => setAgbChecked(e.target.checked)}
                    required
                  />
                  <div>
                    Ich bin mit den <a href="/agb" target="_blank" rel="noopener noreferrer">AGBs</a> und&nbsp;
                    <a href="/datenschutz" target="_blank" rel="noopener noreferrer">Datenschutzbestimmungen</a> einverstanden.<br />
                    Für A1, A2, A und AM Ausbildungen: Ich habe die <a href="/sicherheitsinfo" target="_blank" rel="noopener noreferrer">Sicherheitsinfos</a> gelesen und bin damit einverstanden.
                  </div>
                </label>
                {/* {errors.agbChecked && <p className={props.styles.error2}>{errors.agbChecked}</p>} */}
              </div>

              {/* {isAngebotForAgree && (
                <div className={props.styles.formGroup}>
                  <button
                    type="button"
                    onClick={onUpdateData}
                    disabled={isUpdating}
                    className={props.styles["summary-submit"]}
                  >
                    {isUpdating ? "Speichern..." : "Daten ergänzen"}
                  </button>
                </div>
              )} */}

              {isAngebotForAgree && (
                <div className={props.styles.formGroup} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {/* <button
        type="button"
        onClick={onUpdateData}
        disabled={isUpdating}
        className={props.styles["summary-submit"]}
      >
        {isUpdating ? "Speichern..." : "Daten ergänzen"}
      </button> */}
                  {!isModerator && (
                    <button
                      type="button"
                      onClick={(e) => onCheckGutschein && onSubmit && onSubmit(e)}
                      /* disabled={!agbChecked} */                      // пока не согласился с AGB — не подписывать
                      className={props.styles["summary-submit"]}
                    >
                      Zusammenfassung
                    </button>
                  )}
                  {/* {!isModerator && (
                    <button
                      type="button"
                      onClick={() => onOpenSignature && onOpenSignature()}
                      className={props.styles["summary-submit"]}
                    >
                      Unterschreiben
                    </button>
                  )} */}
                </div>
              )}


              {/* {updateMessage && <div className={props.styles.updateMessage}>{updateMessage}</div>} */}
               
                <div className={`${props.styles.successOverlay} ${updateMessage && "open"}`}>
                  <div className={props.styles.successMSG}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="#fefefe"><path d="m424-408-86-86q-11-11-28-11t-28 11q-11 11-11 28t11 28l114 114q12 12 28 12t28-12l226-226q11-11 11-28t-11-28q-11-11-28-11t-28 11L424-408Zm56 328q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                    <h1>Geschafft!</h1>
                    <p>{updateMessage}</p>
                    {/* <button className="large button pagelink">Mehr Infos zur Klasse</button> */}
                    <button className="large button pagelink">Zurück zur Startseite</button>
                  </div>
                </div>
              {/* } */}

              {/* сабмит */}
              {!isAngebotForAgree && (
                <div className={props.styles.formGroup}>
                  <button
                    className={props.styles["summary-submit"]}
                    /* type="submit" */
                    onClick={(e) => onSubmit && onSubmit(e)}
                    disabled={submitting}
                  >
                    {isModerator ? "Speichern" : "Anfrage senden"}
                  </button>
                </div>
              )}
            </div>

            
          {/* </div> */}
        </form>
      </div>
    </div>
  );
}

export default memo(Step7Panel);
